
import React, { useState } from 'react'

const AddTodo = (props) => {
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");

    const submit = (e) => {
        e.preventDefault();
        if (!title || !desc) {
            alert("Title or Description cannot be blank.")
        }
        else {
            props.addTodo(title, desc);
            setTitle("");
            setDesc("");
        }
    }

    // let mystyle ={
    //     background: "#e3f2fd"
    // }

    return (
        <>

        <div className='container mt-3' style={{backgroundColor: props.mode === 'dark'?'#2C3333':'#e3f2fd'}} >
            <h3 style={{color:props.mode === 'dark'?'white':'black',backgroundColor: props.mode === 'dark'?'#00005C':'#8FD6E1'}}> <strong>Add a ToDO</strong></h3>
            <form onSubmit={submit}>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label" style={{color:props.mode === 'dark'?'white':'black'}}>Todo Title</label>
                    {/* <input type="text" value={title} onChange={(e) => { setTitle(e.target.value) }} className="form-control" id="title" /> */}
                    <input type="text" value={title} style={{backgroundColor: props.mode === 'dark'?'#303134':'white',color:props.mode === 'dark'?'white':'black'}} onChange={(e) => { setTitle(e.target.value) }} className="form-control" id="title" />
                </div>
                <div className="mb-3">
                    <label htmlFor="desc" className="form-label" style={{color:props.mode === 'dark'?'white':'black'}}>Todo Description</label>
                    <input type="text" value={desc} style={{backgroundColor: props.mode === 'dark'?'#303134':'white',color:props.mode === 'dark'?'white':'black'}} onChange={(e) => { setDesc(e.target.value) }} className="form-control" id="desc" />
                </div>
                <button type="submit" className="btn btn-sm btn-success my-3"><b>Add ToDo</b></button>
            </form>
        </div>
        </>
    )
}

export default AddTodo
